import { type SetStateAction, type Dispatch } from 'react'
import { FullscreenModal } from '@/components/global/FullscreenModal/FullscreenModal'
import { Flex } from '@/components/priority/Flex/Flex'
import { PdfViewerHeader } from '@/components/pdfRender/PdfViewerHeader'
import { PdfViewerFooter } from '@/components/pdfRender/PdfViewerFooter'
import { PdfViewerContent } from '@/components/pdfRender/PdfViewerContent'
import type { StatusKey, PdfStatusKey, ApplicationType } from '@messenger/types'
import type { ProofGalleryDetails } from '@/hooks/pdf/usePdfViewer'
import { zLayers } from '@/utils/styling/zLayers'

export type PdfViewerProps = {
  customizeUrl?: string
  canCustomize: boolean
  disclaimerAcknowledged: boolean
  isProof?: boolean
  pdfGenerationProgress: number
  pdfGenerationStatus: PdfStatusKey
  pdfUrl: string
  handleClosePdfViewer: () => void
  handleFinalizePdf: () => Promise<void>
  setDisclaimerAcknowledged: Dispatch<SetStateAction<boolean>>
  setProductStatus: (status: StatusKey) => Promise<void>
  productStatus: StatusKey
  showPdfViewer: boolean
  applicationType?: ApplicationType
  proofGalleryDetails?: ProofGalleryDetails | null
}

export const PdfViewer = ({
  canCustomize,
  customizeUrl,
  isProof = false,
  disclaimerAcknowledged,
  setDisclaimerAcknowledged,
  pdfGenerationProgress,
  pdfGenerationStatus,
  pdfUrl,
  handleClosePdfViewer,
  handleFinalizePdf,
  productStatus,
  showPdfViewer,
  setProductStatus,
  applicationType,
  proofGalleryDetails,
}: PdfViewerProps) => {
  return (
    <FullscreenModal
      show={[showPdfViewer, handleClosePdfViewer]}
      hideClose={true}
      $zIndex={zLayers.topLayer}
    >
      <Flex column width="100vw" height="100vh" gap="0">
        <PdfViewerHeader
          canCustomize={canCustomize}
          customizeUrl={customizeUrl}
          isProof={isProof}
          handleClosePdfViewer={handleClosePdfViewer}
          pdfUrl={pdfUrl}
          pdfGenerationStatus={pdfGenerationStatus}
          setProductStatus={setProductStatus}
          proofGalleryDetails={proofGalleryDetails}
          applicationType={applicationType}
        />

        <PdfViewerContent
          isProof={isProof}
          pdfUrl={pdfUrl}
          pdfGenerationProgress={pdfGenerationProgress}
          pdfGenerationStatus={pdfGenerationStatus}
          proofGalleryDetails={proofGalleryDetails}
        />

        {isProof && (
          <PdfViewerFooter
            disclaimerAcknowledged={disclaimerAcknowledged}
            setDisclaimerAcknowledged={setDisclaimerAcknowledged}
            handleFinalizePdf={handleFinalizePdf}
            pdfUrl={pdfUrl}
            pdfGenerationStatus={pdfGenerationStatus}
            productStatus={productStatus}
            applicationType={applicationType}
            proofGalleryDetails={proofGalleryDetails}
          />
        )}
      </Flex>
    </FullscreenModal>
  )
}
